/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name icon-ai-powered
 * @description Displays the AI Powered icon, this is pulled from the MUI icon we use in React.
 */
angular.module('mercury.directives.icon-ai-powered', [])
.directive('iconAiPowered', function() {
  return {
    restrict: 'E',
    template: '<svg class="svg-icon-root" focusable="false" viewBox="0 0 24 24">' +
                '<path d="m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25z"></path>' +
              '</svg>',
    }
  })